"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The SortenBestellung model module.
 * @module model/SortenBestellung
 * @version 1.0.44
 */
var SortenBestellung = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SortenBestellung</code>.
   * Bestellinfos für eine Sorte
   * @alias module:model/SortenBestellung
   * @param iso {String} 3 Buchstabiger ISO Ländercode
   * @param euro {Number} Betrag in Euro
   * @param fremdwaehrung {Number} Betrag der bestellten Sorte
   * @param stueckelung {String} Stückelungsgrößen
   * @param betragStueckelung {String} gewünschter Betrag der Stückelungen
   * @param kennziffer {String} Kennziffer der Sorte aus der Kursliste
   */
  function SortenBestellung(iso, euro, fremdwaehrung, stueckelung, betragStueckelung, kennziffer) {
    _classCallCheck(this, SortenBestellung);
    SortenBestellung.initialize(this, iso, euro, fremdwaehrung, stueckelung, betragStueckelung, kennziffer);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(SortenBestellung, null, [{
    key: "initialize",
    value: function initialize(obj, iso, euro, fremdwaehrung, stueckelung, betragStueckelung, kennziffer) {
      obj['iso'] = iso;
      obj['euro'] = euro;
      obj['fremdwaehrung'] = fremdwaehrung;
      obj['stueckelung'] = stueckelung;
      obj['betragStueckelung'] = betragStueckelung;
      obj['kennziffer'] = kennziffer;
    }

    /**
     * Constructs a <code>SortenBestellung</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SortenBestellung} obj Optional instance to populate.
     * @return {module:model/SortenBestellung} The populated <code>SortenBestellung</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SortenBestellung();
        if (data.hasOwnProperty('iso')) {
          obj['iso'] = _ApiClient.default.convertToType(data['iso'], 'String');
        }
        if (data.hasOwnProperty('euro')) {
          obj['euro'] = _ApiClient.default.convertToType(data['euro'], 'Number');
        }
        if (data.hasOwnProperty('fremdwaehrung')) {
          obj['fremdwaehrung'] = _ApiClient.default.convertToType(data['fremdwaehrung'], 'Number');
        }
        if (data.hasOwnProperty('stueckelung')) {
          obj['stueckelung'] = _ApiClient.default.convertToType(data['stueckelung'], 'String');
        }
        if (data.hasOwnProperty('betragStueckelung')) {
          obj['betragStueckelung'] = _ApiClient.default.convertToType(data['betragStueckelung'], 'String');
        }
        if (data.hasOwnProperty('rate')) {
          obj['rate'] = _ApiClient.default.convertToType(data['rate'], 'Number');
        }
        if (data.hasOwnProperty('gebuehren')) {
          obj['gebuehren'] = _ApiClient.default.convertToType(data['gebuehren'], 'Number');
        }
        if (data.hasOwnProperty('position')) {
          obj['position'] = _ApiClient.default.convertToType(data['position'], 'Number');
        }
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SortenBestellung</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SortenBestellung</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(SortenBestellung.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['iso'] && !(typeof data['iso'] === 'string' || data['iso'] instanceof String)) {
        throw new Error("Expected the field `iso` to be a primitive type in the JSON string but got " + data['iso']);
      }
      // ensure the json data is a string
      if (data['stueckelung'] && !(typeof data['stueckelung'] === 'string' || data['stueckelung'] instanceof String)) {
        throw new Error("Expected the field `stueckelung` to be a primitive type in the JSON string but got " + data['stueckelung']);
      }
      // ensure the json data is a string
      if (data['betragStueckelung'] && !(typeof data['betragStueckelung'] === 'string' || data['betragStueckelung'] instanceof String)) {
        throw new Error("Expected the field `betragStueckelung` to be a primitive type in the JSON string but got " + data['betragStueckelung']);
      }
      // ensure the json data is a string
      if (data['kennziffer'] && !(typeof data['kennziffer'] === 'string' || data['kennziffer'] instanceof String)) {
        throw new Error("Expected the field `kennziffer` to be a primitive type in the JSON string but got " + data['kennziffer']);
      }
      return true;
    }
  }]);
}();
SortenBestellung.RequiredProperties = ["iso", "euro", "fremdwaehrung", "stueckelung", "betragStueckelung", "kennziffer"];

/**
 * 3 Buchstabiger ISO Ländercode
 * @member {String} iso
 */
SortenBestellung.prototype['iso'] = undefined;

/**
 * Betrag in Euro
 * @member {Number} euro
 */
SortenBestellung.prototype['euro'] = undefined;

/**
 * Betrag der bestellten Sorte
 * @member {Number} fremdwaehrung
 */
SortenBestellung.prototype['fremdwaehrung'] = undefined;

/**
 * Stückelungsgrößen
 * @member {String} stueckelung
 */
SortenBestellung.prototype['stueckelung'] = undefined;

/**
 * gewünschter Betrag der Stückelungen
 * @member {String} betragStueckelung
 */
SortenBestellung.prototype['betragStueckelung'] = undefined;

/**
 * Umrechnungskurs bzgl 1 Euro
 * @member {Number} rate
 */
SortenBestellung.prototype['rate'] = undefined;

/**
 * anfallende Gebühren für diese Sorte
 * @member {Number} gebuehren
 */
SortenBestellung.prototype['gebuehren'] = undefined;

/**
 * Position in der Liste der Bestellten Sorten
 * @member {Number} position
 */
SortenBestellung.prototype['position'] = undefined;

/**
 * Kennziffer der Sorte aus der Kursliste
 * @member {String} kennziffer
 */
SortenBestellung.prototype['kennziffer'] = undefined;
var _default = exports.default = SortenBestellung;